import React, { useState } from "react";
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import { ColorRing } from 'react-loader-spinner'

export default function AuthSearch() {

	const [spinner, setSpinner] = useState(false);
	const [postResult, setPostResult] = useState(null);
	const [id, setId] = React.useState('');
	const [cpt, setCPT] = React.useState('');
	const [dos, setDOS] = React.useState(null);
	const baseURL = "https://veritasallies.net/opensearch/authcheck";

	async function getData() {

		try {

			let targetURL = baseURL + "/" + id + "/" + dos;

			if (cpt !== '') {
				targetURL = baseURL + "/" + id + "/" + dos + "/" + cpt;
			} else {
				throw new Error('CPT Code is Manadatory. Please enter.');
			}
			
			setSpinner(true);
			const res = await fetch(`${targetURL}`, {
				method: "get",
			});

			if (!res.ok && res.status !== 404) {
				const message = `An error has occured: ${res.status} - ${res.statusText}`;
				throw new Error(message);
			}

			const data = await res.text();

			const result = {
				status: res.status + "-" + res.statusText,
				headers: {
					"Content-Type": res.headers.get("Content-Type"),
					"Content-Length": res.headers.get("Content-Length"),
				},
				data: data
			};

			setSpinner(false);
			setPostResult(result.data);
		} catch (err) {
			setSpinner(false);
			setPostResult(err.message);
		}
	}

	const handleIdChange = (event) => {
		setId(event.target.value);
	};

	const handleCPTChange = (event) => {
		setCPT(event.target.value);
	};

	const handleDateChange = (event) => {
		if (validateDate(event.target.value)) {
			removeDashes(event.target.value);
			setPostResult(null);
		} else {
			setPostResult(<h3 style={{ color: "red" }}>Date of Service Exceeds 12 months</h3>);
		}

	};

	function validateDate(date) {
		var limit = Date.today().addMonths(-12).getTime();
		var enteredDate = Date.parse(date).getTime();
		if (enteredDate < limit) {
			setDOS(null);
			return false;
		}
		return true;
	}

	const removeDashes = (value) => {
		setDOS(value.replace(/-/g, ""));
	}

	return (
		<div>
			<Stack spacing={2} direction="row" sx={{ justifyContent: "center" }}>
				<TextField id="outlined-basic" label="MemberId" variant="outlined"
					InputLabelProps={{
						shrink: true,
					}}
					onChange={handleIdChange} />
				<TextField
					id="date"
					label="Date of Service"
					type="date"
					sx={{ width: 220 }}
					InputLabelProps={{
						shrink: true,
					}}
					onChange={handleDateChange}
				/>
				<TextField id="outlined-basic" label="CPT Code (Mandatory)" variant="outlined"
					InputLabelProps={{
						shrink: true,
					}}
					onChange={handleCPTChange} />
				<Button onClick={dos && getData} variant="outlined">Search</Button>
				<ColorRing
					visible={spinner}
					height="80"
					width="80"
					ariaLabel="blocks-loading"
					wrapperStyle={{}}
					wrapperClass="blocks-wrapper"
					colors={['#e15b64', '#f47e60', '#f8b26a', '#abbd81', '#849b87']}
				/>
			</Stack>
			<center><h2>{postResult && <div className="alert alert-secondary mt-2" role="alert"><pre>{postResult}</pre></div>}</h2></center>
		</div>
	);


}